import { Injectable } from '@angular/core';

// import {
//     Camera,
//     CameraDirection,
//     CameraResultType,
//     CameraSource
// } from '@capacitor/camera';


// Enum para compatibilidade (se não estiver definido)
export enum CameraSource {
    Camera = 'CAMERA',
    Photos = 'PHOTOS',
    Prompt = 'PROMPT'
}

import { Platform } from '@ionic/angular';

@Injectable({
    providedIn: 'root'
})
export class CameraService {

    constructor(private Platform: Platform) { }

    // /**
    //  * 
    //  * @returns 
    //  */
    private async getCameraStatus(): Promise<boolean> {

        try {
            // Verifica permissões atuais sem solicitar acesso
            if (navigator.permissions) {
                const permission = await navigator.permissions.query({ name: 'camera' as PermissionName });
                return permission.state === 'granted';
            }

            // Fallback: tenta acessar a câmera
            const stream = await navigator.mediaDevices.getUserMedia({ video: true });
            stream.getTracks().forEach(track => track.stop());
            return true;
        } catch (error) {
            return false;
        }
    }

    private async requestPermissions(): Promise<boolean> {
        try {
            // Solicita acesso à câmera
            const stream = await navigator.mediaDevices.getUserMedia({ video: true });
            // Libera a câmera imediatamente após obter permissão
            stream.getTracks().forEach(track => track.stop());
            return true;
        } catch (error) {
            console.error('Permissão de câmera negada:', error);
            return false;
        }
    }

    /**
     * Verifica e solicita permissões de câmera se necessário
     * @returns Status da permissão e mensagem de erro caso ocorra
     */
    public async CameraPermissions(camerasource: CameraSource = CameraSource.Camera) {
        const hasPermission = await this.getCameraStatus();

        if (!hasPermission && camerasource === CameraSource.Camera) {
            const permissionGranted = await this.requestPermissions();
            if (!permissionGranted) {
                return {
                    error: 'Ocorreu um problema ao acessar a funcionalidade, verifique as permissões',
                    status: false
                };
            }
        }

        return { error: null, status: true };
    }


    // /**
    //  * 
    //  * @param camerasource 
    //  */
    // public async GetPhoto(camerasource = CameraSource.Camera) {

    //     const { error, status } = await this.CameraPermissions(camerasource);

    //     if (!status && error) {

    //         return { error: error, capturedPhoto: null };
    //     }

    //     const capturedPhoto = await Camera.getPhoto({
    //         resultType: CameraResultType.Base64,
    //         source: camerasource,
    //         quality: 75,
    //         height: 720,
    //         width: 720,
    //         allowEditing: false,
    //         direction: CameraDirection.Front,
    //         // format: 'jpeg'
    //         correctOrientation: true
    //     });

    //     return { error: null, capturedPhoto: capturedPhoto };
    // }

}
